import { createContext } from 'react'
import { INotification } from 'components/types/Notification'

export interface INotificationContext {
  handleAdd: (notification: INotification) => INotification | void
  handleRemove: (notification: INotification) => void
  items: INotification[]
}

export const NotificationContext = createContext<INotificationContext>({
  items: [],
  handleAdd: () => undefined,
  handleRemove: () => undefined
})
